export default {"src":"/_next/static/media/borjomi_black.3bfc5196.svg","height":31,"width":162,"blurWidth":0,"blurHeight":0};